import Exim from 'exim';
import Api from 'tm3-core/api';

export default Exim.createStore({
  actions: ['requestLock', 'releaseLock', 'appointmentIsSame', 'clearAllForUser'],

  initial: {
    lock: false,
    needsRefresh: false,
    caseIsLocked: false
  },

  appointmentIsSame(appointment) {
    //Diary.set(processing:true)
    const appt = {
      id: appointment.id,
      startDateTime: appointment.actualStartDateTime || appointment.startDateTime,
      endDateTime: appointment.actualEndDateTime || appointment.endDateTime,
      status: appointment.status,
      practitionerId: appointment.practitionerId,
      locationId: appointment.locationId,
      roomId: appointment.roomId,
      type: appointment.type,
      name: appointment.name,
      description: appointment.description || appointment.comment
    };

    return Api.post('/api/lock/same', appt).then((res) => {
      switch (res.body.result) {
        case '-1':
          return this.set({
            needsRefresh: true,
            lock: false
          });
        //Diary.set(processing:false)
        case '0':
          return this.set({
            needsRefresh: false,
            lock: true
          });
        //Diary.set(processing:false)
        default:
          return this.set({
            needsRefresh: false,
            lockUserName: res.body.result,
            lock: false
          });
      }
    });
  },
  //Diary.set(processing:false)

  requestLock(objectType, objectId) {
    return Api.post('/api/lock/request', { objectType, objectId }).then((res) => {
      if (res.body === false) {
        return this.set({
          lock: true
        });
      } else {
        const { id, userName, objectType } = res.body.result;
        return this.set({
          caseIsLocked: objectType.toUpperCase().trim() === 'H',
          lockUserId: id,
          lockUserName: userName
        });
      }
    });
  },

  releaseLock(objectType, objectId) {
    return Api.post('/api/lock/release', { objectType, objectId });
  },

  clearAllForUser() {
    return Api.post('/api/lock/release/user').then((res) => {
      return this.set({
        lock: false
      });
    });
  }
});
